export const feedback = {
  type: {
    event: 'event',
    session: 'session',
    speaker: 'speaker',
  },
}
